import { Image } from 'expo-image';
import { View, XStack, YStack } from 'tamagui';

import PSBox from '@/components/ui/PSBox';
import PSText from '@/components/ui/PSText';

const IMAGE_W = 54;
const IMAGE_H = 72;

const VARIANTS = {
  light: {
    bg: '$color.backgroundSecondary',
    title: '$color.textDark',
    muted: '$color.textDarkMuted',
  },
  // Sits on the $brandDark home page, so the fill is the translucent panel.
  dark: {
    bg: '$color.panelTranslucent',
    title: '$color.textWhite',
    muted: '$color.textWhiteMuted',
  },
} as const;

export default function UpcomingBookingBanner({
  image,
  title,
  ticketSlotDisplayLine,
  variant = 'light',
}: {
  image: string;
  title: string;
  ticketSlotDisplayLine: string;
  variant?: 'light' | 'dark';
}) {
  const colors = VARIANTS[variant];

  return (
    <PSBox
      alignSelf="stretch"
      bg={colors.bg}
      borderColor="$color.transparent"
      gap="$space.sm"
    >
      <PSText.H3 color={colors.muted}>Upcoming booking</PSText.H3>
      <XStack items="flex-start" gap="$space.sm">
        <View
          width={IMAGE_W}
          height={IMAGE_H}
          rounded="$base"
          overflow="hidden"
        >
          <Image
            source={{ uri: image }}
            style={{ width: IMAGE_W, height: IMAGE_H }}
            contentFit="cover"
            transition={200}
          />
        </View>
        <YStack flex={1} gap="$space.xs">
          <PSText.H2 color={colors.title} numberOfLines={2}>
            {title}
          </PSText.H2>
          <PSText.Body3 color={colors.muted} numberOfLines={1}>
            {ticketSlotDisplayLine}
          </PSText.Body3>
        </YStack>
      </XStack>
    </PSBox>
  );
}
